export class UserAccess {
	id: number;
	roleId: string;
	userId: string;
	customerTreeId: number;
	granted: boolean;
}